import Inspections from "@/pages/Inspections";

// Admin sees ALL inspections via backend scope_filter; reuse the same page.
export default function AdminInspections() {
  return (
    <div data-testid="admin-inspections-page">
      <Inspections />
    </div>
  );
}
